export const getPrincipios = (state) => state.principios.lista
export const getIsCarregandoListaPrincipios = (state) => state.principios.isCarregandoLista
